<script>
  import Header from "./components/Header.svelte";
  import StaffButton from "./components/StaffButton.svelte";
  import SOSButton from "./components/SOSButton.svelte";
  import RoomButton from "./components/RoomButton.svelte";
  import Messages from "./components/Messages.svelte";
  import Protocol from "./components/Protocol.svelte";
  import { io } from "socket.io-client";

  // import _ from "lodash";

  import {
    staffMember,
    roomRequest,
    isDebug
  } from './stores';
  import {
    checkMessage,
    isEmptyObject,
    setTimestamp,
    generateGuid,
    getIndex,
    debugMode,
    sendKAmessage,
    sortMessages,
    buildMessage,
    humanReadableMessage
  } from './utils';
  import {
    onMount
  } from 'svelte';
  const endpoint = "http://localhost:3000";
  const socket = io();
  let staff = [];
  let rooms = [];
  let messages = [];
  let message = {};
  let outgoingMessage = '';

  let log = [];

  isDebug.set(debugMode());
  /* send keep alive message */
  // sendKAmessage(socket);

  // socket.onopen = function (e) {
  //   console.log("[open] Connection established");
  //   console.log(e);
  // };

  socket.on('message', function (msg) {
    console.log(msg)
    let data = msg;
    console.log(data);

    if (checkMessage(data)) {
      message = {
	    message: JSON.parse(data),
      };
      log.push(JSON.stringify(message));
      log = log;
      // console.log(message)
      if (message.message.hasOwnProperty("confirmed")) {
	if (message.message.confirmed == 1) {

	  let mGuid = message.message.guid;
	  // console.log(mGuid);
	  let temp = [...messages];
	  // console.log("temp:", temp)
	  let index = getIndex(temp, mGuid);
	  // console.log(index)
	  temp.splice(index, 1, message);
	  messages = temp;
	} else {
	  messages.push(message);
	}
      }
      if (message.message.hasOwnProperty("sos")) {
	let t = [...messages];
        if (message.message.sos == 0) {
          t.splice(getIndex(t, message.message.guid), 1);
          messages = t;
        } else {
          messages.push(message);
        }
      }
      messages = sortMessages(messages);
      console.log(messages);
    } else {
      log.push(data);
      log = log;
      console.log(data);
    }
  });



  function staffEvent(event) {
    console.log($staffMember);
  }

  function roomEvent(event) {
    console.log($staffMember);
    console.log($roomRequest)
    sendMessage();
  }

  function resolveSOS(event) {
    let temp = event.detail.message;
    let m = JSON.parse(temp);
    m.sos = 0;
    m.resolved = 1;
    outgoingMessage =  buildMessage(m);
    send();
  }

  function confirm(event) {
    let temp = event.detail.message;
    let m = JSON.parse(temp);
    m.confirmed = 1;
    outgoingMessage = buildMessage(m);
    send();
  }

  function sendMessage() {
    let guidStaff = $staffMember.guid;
    let roomGuid = $roomRequest.guid;
    //let hrm = `${$staffMember.name} in ${$roomRequest.name}`;
    let hrm = humanReadableMessage($staffMember, $roomRequest);

    outgoingMessage = buildMessage({
      "staff": guidStaff,
      "room": roomGuid,
      "confirmed": 0,
      "notification": hrm
    });
    send();

    setTimeout(() => {
      staffMember.set(0);
      roomRequest.set(0);
    }, 1000);
  }

  function sos(event) {
    let m = event.detail.item;
    let o = buildMessage({
      "sos": 1,
      "resolved": 0
    });
    console.log(o);
    socket.emit('message', o);
  }

  function send() {
    console.log("sending: " + outgoingMessage);
    socket.emit('message', outgoingMessage);
    outgoingMessage = '';
  }
  onMount(async () => {
    let requests = await Promise.all([fetch('/data/staff.json'), fetch('/data/rooms.json')]);
    try {
      staff = await requests[0].json();
      rooms = await requests[1].json();
      console.log(staff);
      console.log(rooms);
    } catch (error) {
      console.log(error);
    }
  });
</script>

<main>
  <Header></Header>
  <section class="content">
    <section class="button-area">
      <div id="staff" class="staff">
        <ul>
          {#each staff as member}
            <li class="staff-member-button"><StaffButton on:staffevent={staffEvent} item={member} /></li>
          {/each}
          <li class="sos-button"><SOSButton on:sosevent={sos}></SOSButton></li>
        </ul>
      </div>
      <div id="rooms" class="rooms">
        <ul>
          {#each rooms as room}
            <li class="room-number-button"><RoomButton on:roomevent={roomEvent} item={room} /></li>
          {/each}
        </ul>
      </div>
    </section>
    <Messages messages={messages} on:confirm={confirm} on:resolveSOS={resolveSOS} staffMembers={staff} rooms={rooms}></Messages>
  </section>

  {#if $isDebug}
    <Protocol entries={log} />
  {/if}
</main>
